module.exports = __webpack_public_path__ + "pcsg/img/may6.aaac87c3.png";